const en_upf = {
  LOAN_ANALYSING:
    "Your application has been processed. We will contact you once it has been analyzed. Stay tuned!",
};
export default en_upf;
